<template>
    <div>
        <h3 class="relative text-xl sm:text-2xl lg:text-3xl leading-tight md:leading-normal font-bold text-muted-500 text-center">{{ question | trans }}
            <span v-if="required" class="absolute text-primary-100">*</span>
        </h3>
        <p v-if="instructions" class="italic mt-10">{{ instructions | trans }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            question: {
                type: Object,
                required: true
            },
            instructions: Object,
            required: {
                type: Boolean,
                required: true
            },
        }
    }
</script>
